module.exports = __webpack_public_path__ + "img/tokyo.967c8bf8.png";